import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminSystemInfoResponse } from '@utils/types/admin';

/**
 * Hook to fetch on-prem system information
 *
 * GET /api/admin/on-prem/system
 *
 * Returns version, storage driver, K8s namespace, whisper model info, service health
 */
export const useGetAdminSystem = () => {
  const fetchSystem = async () => {
    const url = `api/admin/on-prem/system`;
    const response = await Axios.get<AdminSystemInfoResponse>(url);
    return response.data;
  };

  return useQuery<AdminSystemInfoResponse, AxiosError<BaseError>>(
    ['adminSystem'],
    fetchSystem,
    {
      useErrorBoundary: false,
      refetchInterval: 60000 // Auto-refresh every minute
    }
  );
};
